import Rule from './rule';

export default class UppercaseRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'UPPERCASE';
  }

  run(input) {
    if(typeof input === 'string') {
      return input.toUpperCase();
    }

    return input;
  }
}
